import { CSSProperties } from 'react';
import styled, { css } from 'styled-components';
import { nameof } from '../../utils/stringUtils';

type ISideProps = {
    mode: 'equal';
    count?: number;
} | {
    mode: 'template';
    sizes: string;
} | {
    mode: 'auto';
    size?: string;
};

interface IProps {
    flow?: 'row' | 'column';
    gap?: string;
    columns?: ISideProps;
    rows?: ISideProps;
    templateAreaRows?: string[];
    justifyItems?: CSSProperties['justifyItems'];
    alignItems?: CSSProperties['alignItems'];
}

const Grid = styled.div<IProps>`
  display: grid;
  grid-auto-flow: ${p => p.flow};
  grid-gap: ${p => p.gap};  

  ${p => {
        const columnProps = p.columns;
        if (columnProps === undefined)
            return;

        if (columnProps.mode === 'auto') {
            return css`grid-auto-columns: ${columnProps.size ?? 'min-content'};`;
        }
        else if (columnProps.mode === 'equal') {
            if (columnProps.count !== undefined)
                return css`grid-template-columns: repeat(${columnProps.count}, minmax(1px, 1fr));`;
            else
                return css`grid-auto-columns: 1fr;`;
        }
        else if (columnProps.mode === 'template') {
            return css`grid-template-columns: ${columnProps.sizes};`;
        }
    }};

  ${p => {
        // defaulting in order to not stretch rows
        const rowProps = p.rows ?? { mode: 'auto' };

        if (rowProps.mode === 'auto') {
            return css`grid-auto-rows: ${rowProps.size ?? 'min-content'};`;
        }
        else if (rowProps.mode === 'equal') {
            if (rowProps.count !== undefined)
                return css`grid-template-rows: repeat(${rowProps.count}, minmax(1px, 1fr));`;
            else
                return css`grid-auto-rows: 1fr;`;
        }
        else if (rowProps.mode === 'template') {
            return css`grid-template-rows: ${rowProps.sizes};`;
        }
    }};

  ${p => p.templateAreaRows && css`grid-template-areas: ${p.templateAreaRows.map(r => `"${r}"`).join('\n')};`}

  justify-items: ${p => p.justifyItems};
  align-items: ${p => p.alignItems};
`;

Grid.displayName = nameof({ Grid });
export default Grid;